const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

export async function saveResume(content, fileName, accessToken) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/documents/save-resume`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ content, file_name: fileName }),
    });
    if (!response.ok) return null;
    return response.json();
  } catch {
    return null;
  }
}

export async function getSavedResume(accessToken) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/documents/get-resume`, {
      headers: { 'Authorization': `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    return response.json();
  } catch {
    return null;
  }
}

export async function getSavedResumes(accessToken) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/documents/get-resumes`, {
      headers: { 'Authorization': `Bearer ${accessToken}` },
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data.resumes || [];
  } catch {
    return [];
  }
}

export async function saveNamedResume(content, name, accessToken) {
  const response = await fetch(`${API_BASE_URL}/api/documents/save-named-resume`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ content, name }),
  });
  if (!response.ok) throw new Error('Failed to save resume');
  return response.json();
}
